import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {CenteredHeader, CenteredInfo, CenteredLayout} from '../../layout/centered/components';
import MessageBox from '../components/MessageBox';

const ForgotPasswordConfirmation: React.FC = () => {
  const {t} = useTranslation();
  return (
    <CenteredLayout sectionId="forgot-password-confirmation-section">
      <CenteredHeader
        title={t('common.pages.forgotPasswordConfirmation.title')}
        subtitle={t('common.pages.forgotPasswordConfirmation.subtitle')}
      />

      <MessageBox
        icon="fa fa-envelope-open"
        message={t('common.pages.forgotPasswordConfirmation.message')}
      />

      <CenteredInfo className="mt-8">
        {t('common.pages.forgotPasswordConfirmation.rememberPassword')}&nbsp;
        <Link
          className="text-gray-800 hover:underline cursor-pointer font-medium"
          to="/login"
        >
          {t('common.pages.forgotPasswordConfirmation.signInHere')}
        </Link>
      </CenteredInfo>
    </CenteredLayout>
  );
};

export default ForgotPasswordConfirmation;
